import { User } from './../../../models/user';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';
import { environment } from 'src/environments/environment';
import { PageEvent } from '@angular/material/paginator';
import { DialogConfirmComponent } from '../../dialog-confirm/dialog-confirm.component';
import { NewWeekTimeChallengeComponent } from './new-week-time-challenge/new-week-time-challenge.component';
import { NewSubTimeChallengeComponent } from './new-sub-time-challenge/new-sub-time-challenge.component';
import { EditSubTimeChallengeComponent } from './edit-sub-time-challenge/edit-sub-time-challenge.component';
import { EditWeekTimeChallengeComponent } from './edit-week-time-challenge/edit-week-time-challenge.component';
import * as moment from 'moment';
import { NewTimeChallengeComponent } from './new-time-challenge/new-time-challenge.component';
import { ExcelService } from 'src/app/services/excel.service';
import 'moment-timezone';

@Component({
  selector: 'vex-time-challenge',
  templateUrl: './time-challenge.component.html',
  styleUrls: ['./time-challenge.component.scss']
})
export class TimeChallengeComponent implements OnInit {
  environmentNode = environment.baseURL.node;
  expandedCardId: any;
  challenges: any = [];
  pageSize = 10;
  pageNumber = 1;
  lunghezza: any;

  constructor(private restService: RestService, public guiService: GuiService, public translate: TranslateService, private dialog: MatDialog, private clipboard: Clipboard, private excelService: ExcelService) { }

  ngOnInit(): void {
    this.guiService.showSpinner = false;
    if(this.guiService.userLogged){
      this.getTimeChallenges();
    }else{
      this.getCurrent();
    }
  }

  getCurrent() {
    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.restService.getService('current_user', '').subscribe((ris) => {
      this.guiService.userLogged = ris;
      this.getTimeChallenges();
    })
  }

  getTimeChallenges() {
    setTimeout(() => this.guiService.showSpinner = true, 0)
    const param = {
      page: this.pageNumber,
      size: this.pageSize,
      userId: this.guiService.userLogged.user.id
    };
    this.restService.postService('node', '/get-time-challenges', param).subscribe((ris) => {
      this.challenges = ris.items;
      this.lunghezza = ris.totalItems;
      this.guiService.showSpinner = false;
    })
  }

  onPageChanged(pageEvent: PageEvent) {
    this.pageNumber = pageEvent.pageIndex + 1;
    this.pageSize = pageEvent.pageSize;
    this.getTimeChallenges();
  }

  deleteChallenge(id) {
    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.dialog.open(DialogConfirmComponent, {
      width: '250px',
      enterAnimationDuration: '0ms',
      exitAnimationDuration: '1ms',
      panelClass: 'dialog-modalbox',
      data: {
        type: 'remove-challenge',
        id: id
      }
    }).afterClosed().subscribe((ris) => {
      if (ris != 'true') {
        this.getTimeChallenges();
      }
    })
  }

  deleteSubChallenge(index, challengeId) {
    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.dialog.open(DialogConfirmComponent, {
      width: '250px',
      enterAnimationDuration: '0ms',
      exitAnimationDuration: '1ms',
      panelClass: 'dialog-modalbox',
      data: {
        type: 'remove-sub-challenge',
        id: {
          index: index,
          challengeId: challengeId
        }
      }
    }).afterClosed().subscribe((ris) => {
      if (ris != 'true') {
        this.getTimeChallenges();
      }
    })
  }

  createSubTimeChallenge(item) {
    this.dialog.open(NewSubTimeChallengeComponent, {
      height: '85vh',
      panelClass: 'custom-modalboxx',
      disableClose: true,
      hasBackdrop: true,
      data: item
    }).afterClosed().subscribe((sub) => {
      if (sub == 'done') {
        this.getTimeChallenges();
      }
    })
  }

  editSubTimeChallenge(challenge, index) {
    this.dialog.open(EditSubTimeChallengeComponent, {
      height: '85vh',
      panelClass: 'custom-modalboxx',
      disableClose: true,
      hasBackdrop: true,
      data: { challenge: challenge, index: index }
    }).afterClosed().subscribe((sub) => {
      if (sub == 'done') {
        this.getTimeChallenges();
      }
    })
  }

  newWeekTimeChallenge(item, challengeId, challengeIndex) {
    this.dialog.open(NewWeekTimeChallengeComponent, {
      height: '85vh',
      panelClass: 'custom-modalboxx',
      disableClose: true,
      hasBackdrop: true,
      data: { item: item, challengeId: challengeId, challengeIndex: challengeIndex }
    }).afterClosed().subscribe((sub) => {
      if (sub == 'done') {
        this.getTimeChallenges();
      }
    })
  }

  editWeekTimeChallenge(challenge, subChallengeIndex, weekIndex) {
    this.dialog.open(EditWeekTimeChallengeComponent, {
      height: '85vh',
      panelClass: 'custom-modalboxx',
      disableClose: true,
      hasBackdrop: true,
      data: { challenge: challenge, challengeIndex: subChallengeIndex, weekIndex: weekIndex }
    }).afterClosed().subscribe((sub) => {
      if (sub == 'done') {
        this.getTimeChallenges();
      }
    })
  }

  deleteWeekTimeChallenge(challengeId, subChallengeIndex, weekIndex) {
    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.dialog.open(DialogConfirmComponent, {
      width: '250px',
      enterAnimationDuration: '0ms',
      exitAnimationDuration: '1ms',
      panelClass: 'dialog-modalbox',
      data: {
        type: 'remove-week-challenge',
        id: {
          subChallengeIndex: subChallengeIndex,
          challengeId: challengeId,
          weekIndex: weekIndex
        }
      }
    }).afterClosed().subscribe((ris) => {
      if (ris != 'true') {
        this.getTimeChallenges();
      }
    })
  }

  updateTimeChallenge(item) {
    console.debug(item)

    setTimeout(() => this.guiService.showSpinner = true, 0)
    const param = {
      userId: this.guiService.userLogged.user.id,
      challengeId: item._id,
      startDate: moment(item.startDate).format('YYYY-MM-DD'),
      endDate: moment(item.endDate).format('YYYY-MM-DD'),
      acceptancePeriod: item.acceptancePeriod,
      i18nTitle: item.i18nTitle,
      i18nDescription: item.i18nDescription,
      i18nThumb: item.i18nThumb,
      i18nThumbDetail: item.i18nThumbDetail,
      draft: item.draft
    };
    this.restService.postService('node', '/update-time-challenge', param).subscribe((ris) => {
      this.getTimeChallenges()
    })
  }

  newTimeChallenge() {
    this.expandedCardId = null;
    this.dialog.open(NewTimeChallengeComponent, {
      height: '85vh',
      panelClass: 'custom-modalboxx',
      disableClose: true,
      hasBackdrop: true,
    }).afterClosed().subscribe((sub) => {
      if (sub == 'done') {
        this.getTimeChallenges();
      }
    })
  }

  customExcelDownload(chall) {
    console.debug(chall)
    const param = {
      userId: this.guiService.userLogged.user.id,
      challengeId: chall._id
    }
    this.guiService.showSpinner = true;
    this.restService.postService('node', '/time-challenge-report', param).subscribe((ris) => {
      let tmpArr = []
      for (let i = 0; i < ris.length; i++) {
        let item = ris[i]
        tmpArr.push({
          email: item.email,
          acceptDate: item.acceptDate ? item.acceptDate : '',
          challengeAccepted: chall.challenges[item.challengeNumber].i18nTitle[this.translate.currentLang.toUpperCase()]
        })
      }
      let excelJsonData: any = tmpArr;
      this.excelService.exportAsExcelFile(excelJsonData, "Challenge report_"+chall.i18nTitle[this.translate.currentLang.toUpperCase()]);
      this.guiService.showSpinner = false;
    })

  }

  getDateForPicker(dateUtcString: string): Date {
    const mUtc = moment.utc(dateUtcString);
    const mRome = mUtc.tz('Europe/Rome').startOf('day');

    const offsetRome = mRome.utcOffset();
    const offsetLocal = moment().utcOffset();

    const diffOffsetMinutes = offsetRome - offsetLocal;

    return new Date(mRome.toDate().getTime() + diffOffsetMinutes * 60 * 1000);
  }

  expandCard(item: any){
    console.debug(item)
    console.debug(this.getDateForPicker(item.startDate))
    item.startDate = this.getDateForPicker(item.startDate);
    item.endDate = this.getDateForPicker(item.endDate);

    this.expandedCardId = item._id;
    console.debug(this.challenges)
  }
}
